import Registry from "../../libs/register_storage";
import AbstractService from "../abstract.service";

/**
 * Common configuration fetched from API side.
 */
export default class CommonService extends AbstractService {
  static API_ROUTES = {
    getCurrencies: "/currencies",
    getTimeZones: "/time_zones",
    getGoalTypes: "/goal_types",
    getHealth: "/health",
    getDealChannels: "/deal_channels",
    getPublishers: "/publishers",
    getSupplySources: "/supply_sources",
    getCurrencyRate: "/currency-rates/{0}",
  };

  constructor() {
    super();
    this.cache = new Registry(window.sessionStorage);
  }

  /**
   * Call health endpoint
   * @return {Promise}
   */
  async getHealth() {
    return await this.api_server.get(CommonService.API_ROUTES.getHealth);
  }

  /**
   * Fetch the list of available currencies.
   * @return {Promise}
   */
  async getCurrencies() {
    // return {"data": [{"currency_code": "ARS", "id": 1, "status": true, "symbol": "$", "title": "Argentine Peso"}, {"currency_code": "AUD", "id": 2, "status": true, "symbol": "$", "title": "Australian Dollar"}, {"currency_code": "BRL", "id": 3, "status": true, "symbol": "R$", "title": "Brazilian Real"}, {"currency_code": "GBP", "id": 4, "status": true, "symbol": "\u00a3", "title": "British Pound"}, {"currency_code": "BGN", "id": 35, "status": true, "symbol": "\u043b\u0432", "title": "Bulgarian Lev"}, {"currency_code": "CAD", "id": 5, "status": true, "symbol": "$", "title": "Canadian Dollar"}, {"currency_code": "CLP", "id": 6, "status": true, "symbol": "$", "title": "Chilean Peso"}, {"currency_code": "CNY", "id": 7, "status": true, "symbol": "\u00a5", "title": "Chinese Yuan Renminb"}, {"currency_code": "COP", "id": 8, "status": true, "symbol": "$", "title": "Colombian Peso"}, {"currency_code": "CZK", "id": 9, "status": true, "symbol": "K\u010d", "title": "Czech Koruna"}, {"currency_code": "DKK", "id": 10, "status": true, "symbol": "kr", "title": "Danish Krone"}, {"currency_code": "EGP", "id": 11, "status": true, "symbol": "\u00a3", "title": "Egyptian Pound"}, {"currency_code": "AED", "id": 12, "status": true, "symbol": "\u00a0\u062f.\u0625", "title": "Emirati Dirham"}, {"currency_code": "EUR", "id": 13, "status": true, "symbol": "\u20ac", "title": "Euro"}, {"currency_code": "FJD", "id": 36, "status": true, "symbol": "FJ$", "title": "Fijian Dollar"}, {"currency_code": "HKD", "id": 14, "status": true, "symbol": "HK$", "title": "Hong Kong Dollar"}, {"currency_code": "HUF", "id": 37, "status": true, "symbol": "Ft", "title": "Hungarian Forint"}, {"currency_code": "ISK", "id": 38, "status": true, "symbol": "kr", "title": "Icelandic Kr\u00f3na"}, {"currency_code": "INR", "id": 15, "status": true, "symbol": "\u20b9", "title": "Indian Rupee"}, {"currency_code": "IDR", "id": 39, "status": true, "symbol": "Rp", "title": "Indonesian Rupiah"}, {"currency_code": "ILS", "id": 16, "status": true, "symbol": "\u20aa", "title": "Israeli Shekel"}, {"currency_code": "JMD", "id": 40, "status": true, "symbol": "J$", "title": "Jamaican Dollar"}, {"currency_code": "JPY", "id": 17, "status": true, "symbol": "\u00a5", "title": "Japanese Yen"}, {"currency_code": "JOD", "id": 41, "status": true, "symbol": "\u00a0\u062f.\u0625", "title": "Jordanian Dinar"}, {"currency_code": "KWD", "id": 18, "status": true, "symbol": "\u062f.\u0643", "title": "Kuwaiti Dinar"}, {"currency_code": "MYR", "id": 19, "status": true, "symbol": "RM", "title": "Malaysian Ringgit"}, {"currency_code": "MXN", "id": 20, "status": true, "symbol": "$", "title": "Mexican Peso"}, {"currency_code": "MAD", "id": 21, "status": true, "symbol": ".\u062f.\u0645", "title": "Moroccan Dirham"}, {"currency_code": "NZD", "id": 22, "status": true, "symbol": "$", "title": "New Zealand Dollar"}, {"currency_code": "NOK", "id": 23, "status": true, "symbol": "kr", "title": "Norwegian Krone"}, {"currency_code": "PKR", "id": 43, "status": true, "symbol": "Rs", "title": "Pakistani Rupee"}, {"currency_code": "PEN", "id": 42, "status": true, "symbol": "S/.", "title": "Peruvian Sol"}, {"currency_code": "PHP", "id": 44, "status": true, "symbol": "\u20b1", "title": "Philippine Peso"}, {"currency_code": "PLN", "id": 24, "status": true, "symbol": "z\u0142", "title": "Polish Zloty"}, {"currency_code": "QAR", "id": 25, "status": true, "symbol": "\ufdfc", "title": "Qatari Riyal"}, {"currency_code": "RUB", "id": 26, "status": true, "symbol": "\u20bd", "title": "Russian Ruble"}, {"currency_code": "SAR", "id": 27, "status": true, "symbol": "\ufdfc", "title": "Saudi Arabian Riyal"}, {"currency_code": "SGD", "id": 28, "status": true, "symbol": "$", "title": "Singapore Dollar"}, {"currency_code": "ZAR", "id": 29, "status": true, "symbol": "R", "title": "South African Rand"}, {"currency_code": "KRW", "id": 30, "status": true, "symbol": "\u20a9", "title": "South Korean Won"}, {"currency_code": "SEK", "id": 31, "status": true, "symbol": "kr", "title": "Swedish Krona"}, {"currency_code": "CHF", "id": 32, "status": true, "symbol": "CHF", "title": "Swiss Franc"}, {"currency_code": "TWD", "id": 45, "status": true, "symbol": "NT$", "title": "Taiwanese New Dollar"}, {"currency_code": "THB", "id": 46, "status": true, "symbol": "\u0e3f", "title": "Thai Baht"}, {"currency_code": "TRY", "id": 33, "status": true, "symbol": "\u20ba", "title": "Turkish Lira"}, {"currency_code": "USD", "id": 34, "status": true, "symbol": "$", "title": "US Dollar"}, {"currency_code": "VEB", "id": 47, "status": true, "symbol": "Bs", "title": "Venezuelan Bolivar"}], "meta": {"status": "ok", "total": 47, "total_count": 47}};
    return await this.api_server.get(CommonService.API_ROUTES.getCurrencies);
  }

  /**
   * Fetch the list of available time zones.
   */
  async getTimeZones() {
    // return {"data": [{"id": 1, "short_title": "EDT", "title": "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima", "value": "America/New_York"}, {"id": 2, "short_title": "BST", "title": "(GMT) London, Lisbon, Casablanca", "value": "Europe/London"}], "meta": {"status": "ok", "total": 2, "total_count": 2}};
    return await this.api_server.get(CommonService.API_ROUTES.getTimeZones);
  }

  /**
   * Fetch the list of available goal types.
   * @param {string} type
   * @param {string} media
   */
  async getGoalTypes(type = "", media = "") {
    const params = type ? { type } : {};
    if (media) params.media = media;

    return await this.api_server.get(CommonService.API_ROUTES.getGoalTypes, params);
  }

  /**
   * Fetch the list of deal channels
   * @return {Promise}
   */
  async getDealChannels() {
    return await this.api_server.get(CommonService.API_ROUTES.getDealChannels);
  }

  /**
   * Fetch the list of Publishers
   * @return {Promise}
   */
  async getPublishers() {
    return await this.api_server.get(CommonService.API_ROUTES.getPublishers);
  }

  /**
   * Fetch the list of Supply Sources
   * @return {Promise}
   */
  async getSupplySources() {
    return await this.api_server.get(CommonService.API_ROUTES.getSupplySources);
  }

  /**
   * Fetch currency rate by currency code
   * @param {string} currencyCode
   * @return {Promise}
   */
  getCurrencyRate(currencyCode) {
    return this.api_server.get(CommonService.API_ROUTES.getCurrencyRate.format(currencyCode.toLowerCase()));
  }
}
